import React, { useState, useEffect } from 'react';
import { findIndex, find } from 'lodash';

import Header from './Header';
import { HighSchoolStandingsCard } from '../../../../cards';

import styles from './attStandings.scss';

const _ = { findIndex, find };

const AdultTeamTennisStandings = (props) => {
    const {
        clubDetails,
        adultTeamTennisStandings,
        adultTeamTennisStandingsState,
        getAdultTeamTennisStandings,
    } = props;

    // only show the top three teams within the standings by default
    const totalStandingsToShow = 3;
    const [standingsCount, setStandingsCount] = useState(totalStandingsToShow);

    useEffect(() => {
        getAdultTeamTennisStandings({ clubId: clubDetails.id });
    }, []);

    const handleShowAll = (showAll) => {
        if (showAll) {
            setStandingsCount(adultTeamTennisStandings.length);
        } else {
            setStandingsCount(totalStandingsToShow);
        }
    };

    const getStandingsToShow = () => {
        const standingsToShow = [];
        if (adultTeamTennisStandings && adultTeamTennisStandings.length) {
            adultTeamTennisStandings.forEach((standing, i) => {
                if (i < standingsCount) {
                    standingsToShow.push(standing);
                }
            });
            const clubId = props.clubDetails.id;

            if (_.findIndex(standingsToShow, { clubId }) === -1) {
                const currentAttStanding = _.find(adultTeamTennisStandings, { clubId });
                standingsToShow.push(currentAttStanding);
            }
        }
        return standingsToShow;
    };

    const gridLayout = ['0.5fr', '0.5fr', '2fr', '1fr', '1fr'];

    return (
        <>
            {adultTeamTennisStandingsState.loading && (
                <>
                    Loading Team Standings
                </>
            )}
            {!adultTeamTennisStandingsState.loading && !adultTeamTennisStandingsState.successful && (
                <>
                    {adultTeamTennisStandingsState.errorMessage ? (
                        <div className={`${styles.unsuccessfulStandingsRetrieval}`}>
                            Unable to retrieve Team Standings
                        </div>
                    )
                        : (
                            <div className={`${styles.unsuccessfulStandingsRetrieval}`}>
                                No standings to display
                            </div>
                        )}
                </>
            )}
            {!adultTeamTennisStandingsState.loading && adultTeamTennisStandingsState.successful && adultTeamTennisStandings.length > 0 && (
                <>
                    <h6>Team Standings</h6>
                </>
            )}
            {adultTeamTennisStandings && (
                <>
                    {adultTeamTennisStandings.length > 0 && (
                        <>
                            <div className="d-none d-md-block">
                                <Header
                                    gridLayout={gridLayout}
                                />
                            </div>
                            {getStandingsToShow().map((standings, i) => (
                                <HighSchoolStandingsCard
                                    key={`standings-${i}`}
                                    {...standings}
                                    currentClubId={props.clubDetails.id}
                                    gridLayout={gridLayout}
                                />
                            ))}
                            <div className="mt32">
                                {standingsCount < adultTeamTennisStandings.length ? (
                                    <a href="#" className="underline" onClick={() => { handleShowAll(true); }}>
                                        Show all
                                    </a>
                                )
                                    : (
                                        <a href="#" className="underline" onClick={() => { handleShowAll(false); }}>
                                            Show less
                                        </a>
                                    )}
                            </div>
                        </>
                    )}
                    {adultTeamTennisStandings.length === 0 && (
                        <div className="text-center mt48">
                            No standings to display
                        </div>
                    )}
                </>
            )}
        </>
    );
};

export default AdultTeamTennisStandings;
